import clsx from "clsx";
import { FC } from "react";

import { PillBanner } from "components/footer/PillBanner";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Tooltip } from "mds/components/Tooltip";
import { PresentPlayFilledIcon } from "mds/icons";

// TODO: consider using more descriptive names for these states instead of colors? e.g. "presenting", "following", etc.
export type PresentationBannerColorType =
  | "black"
  | "green"
  | "light-green"
  | "orange"
  | "light-gray"
  | "dark-gray";

interface PresentationBannerProps {
  color: PresentationBannerColorType;
  bannerText?: string;
  tooltipText?: string | null;
  children?: React.ReactNode;
}

const PRESENT_PLAY_ICON_COLOR_CLASSES: Record<PresentationBannerColorType, string> = {
  black: "bg-green-shade-20 text-white",
  green: "bg-green-shade-20 text-white",
  "light-green": "text-green-shade-20",
  orange: "bg-orange text-white",
  "light-gray": "bg-black-tint-55 text-white",
  "dark-gray": "text-white",
};

const CIRCLE_INFO_ICON_COLOR_CLASSES: Record<PresentationBannerColorType, string> = {
  black: "text-white",
  green: "text-white",
  "light-green": "text-green-shade-40",
  orange: "text-white",
  "light-gray": "text-white",
  "dark-gray": "text-white",
};

export const PresentationBanner: FC<PresentationBannerProps> = ({
  color,
  bannerText,
  tooltipText,
  children,
}) => {
  const InfoIcon = tooltipText ? (
    <Tooltip
      place="top"
      text={tooltipText}
      // Ensure the tooltip is showing above the projector screen
      wrapperClassName={clsx(CIRCLE_INFO_ICON_COLOR_CLASSES[color], "z-[100]")}
    />
  ) : undefined;

  return (
    <PillBanner
      buttonChildren={children}
      kind={color}
      label={t("presentation.presentation_banner_label")}
      textChildren={
        <IconText
          iconEnd={InfoIcon}
          iconStart={<PresentPlayFilledIcon className={PRESENT_PLAY_ICON_COLOR_CLASSES[color]} />}
          text={bannerText}
          hideIconOnMd
          truncateText
        />
      }
    />
  );
};
